import { Box, BoxProps, styled } from "@mui/material";
import React from "react";

const ShimmerBox = styled(Box)<BoxProps & { animate?: boolean }>(
  ({ theme, color, animate }) => ({
    position: "relative",
    overflow: "hidden",
    ...(animate && {
      "&::before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: `linear-gradient(-75deg, transparent 0%, ${
          color
            ? !(color as string).includes(".")
              ? theme.palette[color as keyof typeof theme.palette]?.light ||
                color
              : color
            : theme.palette.common.white
        } 30%, transparent 60%)`,
        backgroundSize: "300% 100%",
        animation: animate
          ? "shimmer 1.5s infinite cubic-bezier(0.33,-0.24, 0.01, 1)"
          : "none",
        backgroundRepeat: "no-repeat"
      }
    })
  })
);

const AnimateShimmer = ({
  color,
  children,
  animate = true,
  ...props
}: BoxProps & {
  color?: string;
  animate?: boolean;
}) => {
  if (!children) {
    return <ShimmerBox color={color} {...props} animate={animate} />;
  }

  return (
    <ShimmerBox color={color} {...props} animate={animate}>
      {React.cloneElement(children as React.ReactElement, {
        ...props
      })}
    </ShimmerBox>
  );
};

export default AnimateShimmer;
